(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function() {
  var cartItemsFooter = document.querySelector('.js-cart-items-footer');
  console.log(cartItemsFooter, 'cartItemsFooter')
  if (!cartItemsFooter) {
    return;
  }
  var announcementBar = document.querySelector('#shopify-section-announcement-bar');
  var pageHeader = document.querySelector('#shopify-section-page-header');

  function setTop() {
    cartItemsFooter.style.top = (announcementBar ? announcementBar.offsetHeight : 0) + (pageHeader ? pageHeader.offsetHeight : 0) + 'px';
  }

  window.addEventListener('resize', setTop);
  setTop();
})();

  } catch(e) { console.error(e); }
})();
})();
